import posthog from "posthog-js";

/** Single source of truth for tour event names so call sites can't typo them. */
export const TOUR_EVENT_NAMES = {
  STARTED: "Playground tour started",
  FINISHED: "Playground tour finished",
} as const;

/** Where the user kicked off the tour from — slices analytics by entry point. */
export type TourStartSource =
  | "playground-header" // Compass button in standalone /playground messages header
  | "prompt-template-header"; // Compass button in the PromptTemplate page action buttons

interface PosthogTrackTourStartedProps {
  source: TourStartSource;
}

export const posthogTrackTourStarted = ({ source }: PosthogTrackTourStartedProps): void => {
  posthog.capture(TOUR_EVENT_NAMES.STARTED, { source });
};

export const posthogTrackTourFinished = (): void => {
  posthog.capture(TOUR_EVENT_NAMES.FINISHED);
};
